import { createSlice } from "@reduxjs/toolkit";
import { WishlistStateType } from "../interfaces/Wishlist";

const initialState: WishlistStateType = {
  loading: false,
  wishlist: null,
  groupWishlist: [],
  singleGroupWishlist: null,
};

export const cartSlice = createSlice({
  name: "wislist",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setWishlist(state, action) {
      state.wishlist = action?.payload;
    },
    setGroupWishlist(state, action) {
      state.groupWishlist = action?.payload;
    },
    setSingleGroupWishlist(state, action) {
      state.singleGroupWishlist = action?.payload;
    },
  },
});

export const {
  setLoading,
  setWishlist,
  setGroupWishlist,
  setSingleGroupWishlist,
} = cartSlice.actions;

export default cartSlice.reducer;
